







import { Vue, Prop, Component } from 'vue-property-decorator';

import LogoImage from '@/components/Atoms/Image/Logo.vue';

@Component({
  components: {
    LogoImage,
  },
})
export default class Logo extends Vue {}
